<template>
    <div class="modal fade" id="modalAddOC" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Gestionar ordenes de compra</h5>
            <button type="button" class="btn btn-danger" @click="cancelAddOC()"><i class="fas fa-times"></i></button>
          </div>
          <div class="col-12">
            <div v-if="eventoSeleccionado" class="col-12">
              <b>Evento Agendado:</b>
              <br>
              <b>{{ eventoSeleccionado.proveedor_obj.id }} - {{ eventoSeleccionado.proveedor_obj.nombre }}</b>
              <br>
              <b>
                {{ eventoSeleccionado.fecha_de | moment("DD-MM-YYYY") }}
              </b>
              &nbsp;/&nbsp;
              <b>
                {{ eventoSeleccionado.fecha_de | moment("hh:mm a") }} - 
                {{ eventoSeleccionado.fecha_a | moment("hh:mm a") }}
              </b>
            </div>
          </div>
          <div class="modal-body">
            <div class="input-group mb-3">
              <input type="text" class="form-control" placeholder="# Orden de Compra" v-model="orderCompraNumber">
              <div class="input-group-append">
                <button class="btn btn-dark" type="button" @click="buscarOrdenCompra">
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </div>
            <div v-if="ordenesCompra.length">
              <div class="row ordencompra-table">
                <div class="col-12" v-for="orden in ordenesCompra" :key="orden.id">
                  <div class="card" style="background-color: #eaf3fc;">
                    <div class="card-body d-flex justify-content-between align-items-center">
                      <div>
                        <b class="card-title" style="font-size: 18px;">
                          #{{ orden.numero }}
                        </b>
                        <br>
                        <b style="font-size: 14px;">
                          {{ orden.proveedor.nombre }}
                        </b>
                        <p class="card-text">Tienda: {{ orden.tienda.nombre }}</p>
                        <p class="card-text">Fecha: {{ orden.fecha }}</p>
                      </div>
                      <button class="btn btn-dark btn-lg" @click="agregarOrdenCompra(orden)">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                     <small v-if="errorMensajeAgendar" class="form_text text-danger pt-1">Consulte con el área de Supply o Comercial</small> 
                  </div>
                </div>
              </div>
            </div>
            <div 
              v-if="
                eventoSeleccionado 
                && Array.isArray(eventoSeleccionado.apl_agenda_orden_compra)
                && eventoSeleccionado.apl_agenda_orden_compra.length"
            >
              <hr>
              <h6>Órdenes de compra añadidas: {{ eventoSeleccionado.apl_agenda_orden_compra.length }}</h6>
                <LoaderComponent :condicion="eventoSeleccionado.apl_agenda_orden_compra.length > 0">
                </LoaderComponent>
                <div class="card" style="background-color: #eaf3fc;"
                  v-for="orden in eventoSeleccionado.apl_agenda_orden_compra" :key="orden.id">
                  <div class="card-body d-flex justify-content-between align-items-center">
                    <div>
                      <span style="font-size: 18px;">
                        <b>#{{ orden.orden_compra.numero }}</b>
                      </span>
                    </div>
                    <button class="btn btn-md btn-danger" style="float: right;">
                      <i class="fas fa-minus" @click="eliminarOrdenCompra(orden)"></i>
                    </button>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import LoaderComponent from "@/components/commons/LoaderComponent.vue";
import CancelarEventoAgendaModal from "@/components/wms/agenda/CancelarEventoAgendaModal";

export default {
  inject: {
    refreshAgenda: {
      from: 'refreshAgenda',
      default: () => {}
    },
  },
  props: {
    eventoSeleccionadoOrdenCompra: {
      type: Object,
    },
    eventos_actuales: {
      type: Array
    },
  },
  components: {
    ProveedoresSelectComponent,
    TiendaSelectComponent,
    LoaderComponent,
    CancelarEventoAgendaModal
  },
  data() {
    return {
      current: {
        errors: [],
      },
      orderCompraNumber: "",
      ordenesCompra: [],
      isSearchAttempted: false,
      eventoSeleccionado: null,
      errorMensajeAgendar: "",
    };
  },
  watch: {
    eventoSeleccionadoOrdenCompra(newVal) {
      this.eventoSeleccionado = newVal;
    },
    isSearchAttempted(newVal) {
      if(newVal){
        this.refreshAgenda();
        this.$nextTick(() => {
          this.isSearchAttempted=false;
        });
      }
    }
  },
  mounted() {
  },
  methods: {
    buscarOrdenCompra() {
      this.errorMensajeAgendar = "";
      if (this.orderCompraNumber.trim() === "") {
        Notifications.alert.error("Ingrese un número de orden de compra válida.");
        return;
      }
      DynamicService.fetch("compras", "orden_compra_e", { numero: this.orderCompraNumber })
        .then((response) => {
          if (response.data.results && response.data.results.length > 0) {
            let filtroAgenda = response.data.results;
            let agendasActivas = filtroAgenda.filter((orden) => orden.estado === "B");
            if (agendasActivas.length === 0) {
              Notifications.alert.warning("No se encontraron órdenes de compra activas", "Intenta con otro número.");
            } else {
              this.ordenesCompra = agendasActivas;
            }
          } else {
            this.ordenesCompra = [];
            Notifications.alert.warning("No se encontraron órdenes de compra", "Intenta con otro número.");
          }
        })
        .catch((error) => {
          Notifications.alert.error("Error al buscar la orden de compra", error.response);
        });
    },
    async agregarOrdenCompra(orden) {
      let self = this;
      await DynamicService.postAction(
        "wms",
        "agenda-proveedores",
        self.eventoSeleccionado.id,
        "agregar_orden_de_compra",
        {
          id: orden.id,
        }
      ).then((response) => {
          self.errorMensajeAgendar = "";
          this.isSearchAttempted = true;
          Notifications.toast.success("Orden de compra", "Orden de compra asignada exitosamente.");
            self.eventoSeleccionado = self.updateEvento;
            self.orderCompraNumber = "";
            self.ordenesCompra = [];
      }).catch((error) => {
          if (error.response.data.detail) {
            Notifications.alert.error("Agregar orden de compra", error.response.data.detail);
            self.errorMensajeAgendar = error.response.data.detail;
          } else {
            self.current.errors = error.response.data;
          }
      });
    },
    async eliminarOrdenCompra(orden) {
      let self = this;
      DynamicService.postAction(
        "wms",
        "agenda-proveedores",
        self.eventoSeleccionado.id,
        "eliminar_orden_de_compra",
        {
          id: orden.orden_compra.id,
        }
      ).then((response) => {
        this.isSearchAttempted = true;
        Notifications.toast.success("¡Éxito!", "Se eliminó la orden de compra.");
      })
        .catch((error) => {
          if (error.response.data.detail) {
            Notifications.toast.error("No se pudo eliminar la orden de compra", error.response.data.detail);
          } else {
            self.current.errors = error.response.data;
          }
        });
    },
    cancelAddOC() {
      this.ordenesCompra = [];
      this.orderCompraNumber = "";
      $("#modalAddOC").modal("hide");
    },
  },
};
</script>
<style scoped>
.center {
  margin-left: 40px;
  margin-top: 10px;
}

.select-size {
  width: 345px;
  height: 24px;
}

.time-size {
  width: 115px;
  height: 24px;
}

.item {
  display: inline;
  width: 100%;
  height: 24px;
}

.invoice-table {
  max-height: 400px;
  overflow-y: auto;
}

.ordencompra-table {
  max-height: 170px;
  overflow-y: auto;
}

.anadidos-table {
  max-height: 193px;
  overflow-y: auto;
}

.badge {
  font-size: 11px;
  padding: 1px 11px;
  border-radius: 12px;
  text-transform: capitalize;
  height: 13px;
  width: 130px;
}
</style>